import { useEpisodeStore } from '@/state/episodeStore';

export function ScriptTab() {
  const script = useEpisodeStore((s) => s.episode?.script ?? '');

  if (!script) {
    return (
      <p className="text-[13px] text-text-4">
        No script yet. Admins author scripts in the legacy admin tool.
      </p>
    );
  }

  return (
    <pre className="whitespace-pre-wrap font-sans text-[13px] leading-relaxed text-text-2">
      {script}
    </pre>
  );
}
